export default __webpack_public_path__ + "static/media/1.03f590da.jpg";